import React from "react";
import "css/components.css";
import F1 from "assets/f_1.png";
import F2 from "assets/f_2.png";
import F3 from "assets/f_3.png";

const showcaseItems = [
  {
    title: "Organized Reports",
    description:
      "We turn messy spreadsheets into clear charts you can read in seconds.",
    image: F1,
    direction: "row",
  },
  {
    title: "Real-Time Readiness",
    description:
      "Use information the moment it is released, because in these markets, timeliness is everything. (WASDE)",
    image: F2,
    direction: "row-reverse",
  },
  {
    title: "AI Guidance",
    description:
      "Our AI acts as a global scout, reading every report to keep you informed about market developments for your operation.",
    image: F3,
    direction: "row",
  },
];

const ShowcaseItem = ({ title, description, image, direction }) => {
  return (
    <div
      className="showcase-item"
      style={{
        display: "flex",
        flexDirection: direction,
        justifyContent: "space-between",
        alignItems: "center",
        gap: "48px",
        width: "100%",
      }}
    >
      <div
        className="showcase-text"
        style={{
          flex: "0 0 40%",
          maxWidth: "450px",
          display: "flex",
          flexDirection: "column",
          alignItems: direction === "row" ? "flex-start" : "flex-end",
        }}
      >
        <h3
          className="title-cool"
          style={{
            fontSize: "36px",
            letterSpacing: "0.02em",
            fontWeight: "600",
            margin: 0,
            color: "#0a2e14",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontSize: "18px",
            marginTop: "16px",
            color: "#3a5a45",
            lineHeight: "1.6",
          }}
        >
          {description}
        </p>
      </div>
      <div
        className="showcase-image"
        style={{
          flex: "0 0 55%",
          maxWidth: "700px",
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            borderRadius: "16px",
            boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.15)",
          }}
        />
      </div>
    </div>
  );
};

export default function HomeShowcase() {
  return (
    <div
      className="bg-circle-center-small showcase-section"
      style={{ flexDirection: "column" }}
    >
      <div className="showcase-badge">WHY NUMBERS.AG?</div>

      <div className="showcase-container">
        {showcaseItems.map((item, index) => (
          <ShowcaseItem
            key={index}
            title={item.title}
            description={item.description}
            image={item.image}
            direction={item.direction}
          />
        ))}
      </div>
    </div>
  );
}
